import { CityState, Parcel } from './types';

export class ParcelSystem {
  /**
   * Scans manually painted parcels to update their road frontage connections.
   * If a painted parcel is adjacent to any road, it links frontageRoadKey.
   */
  public updateParcels(state: CityState): Record<string, Parcel> {
    const updatedParcels: Record<string, Parcel> = { ...state.parcels };
    const roads = state.roads;

    const directions = [
      { dx: 0, dy: -1 }, // North
      { dx: 1, dy: 0 },  // East
      { dx: 0, dy: 1 },  // South
      { dx: -1, dy: 0 }  // West
    ];

    const roadKeys = new Set(Object.keys(roads));

    for (const key of Object.keys(updatedParcels)) {
      const p = updatedParcels[key];

      // If road is built on top of a parcel, delete the parcel
      if (roadKeys.has(key)) {
        if (p.buildingId && state.buildings[key]) {
          delete state.buildings[key];
        }
        delete updatedParcels[key];
        continue;
      }

      // Check adjacent tiles for road access
      let adjacentRoadKey: string | null = null;
      for (const dir of directions) {
        const rx = p.x + dir.dx;
        const ry = p.y + dir.dy;
        const targetRoadKey = `${rx},${ry}`;

        if (roadKeys.has(targetRoadKey)) {
          adjacentRoadKey = targetRoadKey;
          break; // found frontage road!
        }
      }

      p.frontageRoadKey = adjacentRoadKey;

      // If a parcel loses road frontage and has a building, demolish the building after a while!
      if (!adjacentRoadKey && p.buildingId) {
        if (state.buildings[key]) {
          delete state.buildings[key];
        }
        p.buildingId = null;
      }
    }

    return updatedParcels;
  }
}
